import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  async open() {
    this.showDialog();

    const drawer = document.querySelector('cart-drawer-component');
    const shippingLimit = Number(drawer?.dataset.shipping);
    const cart = await fetch('/cart.js').then(r => r.json());

    this.updateShippingTotals(shippingLimit, cart.total_price);

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  updateShippingTotals (shippingLimit, cartTotal) {
      var shippingTexts = document.querySelectorAll(".shipping-text");
      shippingTexts.forEach((shippingWrapper)=>{
          var totalRemaining = shippingLimit - cartTotal;
          if (totalRemaining > 0) {
              var allRemainingText = document.querySelectorAll(".shipping-remaining");
              var valueInPounds = totalRemaining / 100;
              var formattedValue = valueInPounds.toFixed(2);
              var currencyValue = "\xa3" + formattedValue;
              shippingWrapper.innerHTML = '<span class="shipping-text">Spend just <span class="font-bold shipping-remaining">' + currencyValue + "</span> to qualify for free standard UK delivery</span>";
              allRemainingText.forEach((remainingText)=>{
                  remainingText.innerHTML = currencyValue;
              });
              // Calculate progress bar
              var progressBar = document.querySelectorAll(".progress-bar");
              var percentageDiff = cartTotal / shippingLimit * 100;
              progressBar.forEach((bar)=>{
                  bar.style.width = percentageDiff + "%";
              });
          } else {
              shippingWrapper.innerHTML = "You've qualified for free delivery";
              var progressBar = document.querySelectorAll(".progress-bar");
              progressBar.forEach((bar)=>{
                  bar.style.width = "100%";
              });
          }
      });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
